import en from '@/locales/en.json';
import hi from '@/locales/hi.json';
import gu from '@/locales/gu.json';

export type Language = 'en' | 'hi' | 'gu';

export const SUPPORTED_LANGUAGES: { code: Language; label: string; nativeLabel: string }[] = [
  { code: 'en', label: 'English', nativeLabel: 'EN' },
  { code: 'hi', label: 'Hindi', nativeLabel: 'हि' },
  { code: 'gu', label: 'Gujarati', nativeLabel: 'ગુ' },
];

const translations: Record<Language, typeof en> = { en, hi, gu };

export function getTranslations(language: Language): typeof en {
  return translations[language] ?? translations['en'];
}
